<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <span class="font-weight-bold feedback-rule-row" for="inputEmail" v-translate
          >URL Rules</span
        >
        <div class="form-check float-right">
          <toggle-button
            :sync="true"
            color="#FF7518"
            :labels="true"
            v-model="onlyShowSpecified"
          />
        </div>
        <p v-if="!onlyShowSpecified">
          <small class="text-muted">
            {{ label }} on
            <b>every pages</b>
          </small>
        </p>
      </div>
    </div>

    <div
      v-if="onlyShowSpecified"
      style="
        background-color: rgb(243, 248, 255);
        padding: 10px;
        border-radius: 4px;
        margin-bottom: 30px;
      "
    >
      <div class="row mt-2" v-if="onlyShowSpecified">
        <div class="col-md-12">
          <label class="font-weight-bold" for="inputEmail">
            <img width="20" class="d-inline" src="../assets/img/yes.png" />
            {{ label | capitalize }} on ANY of these page:
          </label>
        </div>
      </div>

      <div v-if="onlyShowSpecified">
        <div v-for="(item, key) in ylayer" v-bind:key="key">
          <div
            id="do-show"
            class="row mt-1"
            :class="'row-' + item.id"
            v-if="onlyShowSpecified"
          >
            <div class="col-md-4">
              <select
                class="custom-select rule"
                :value="item.rule"
                @change="updateVal('y', item.id)"
              >
                <option value="simple">Simple match</option>
                <option value="exact">Exact match</option>
                <option value="contain">Contain word</option>
                <option value="regex">Regular expression</option>
              </select>
            </div>
            <div class="col-md-7 pl-0">
              <input
                type="text"
                :value="item.url"
                @keyup="updateVal('y', item.id)"
                class="form-control url"
                placeholder="https://example.com"
                autocomplete="off"
              />
            </div>
            <div class="font-weight-bold col-md-1 my-auto pl-0 cursor-pointer">
              <!-- <font @click="addRow('y')" class="text-primary">+</font> -->
              <font
                style="display: none"
                @click="deleteRow(item.id)"
                class="text-danger y-delete"
              >
                <font-awesome-icon icon="trash" />
              </font>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-1" v-if="onlyShowSpecified">
        <div class="col-md-4"></div>
        <div class="col-md-7 pl-0 text-primary cursor-pointer text-right">
          <span @click="addRow('y')">+ add another url</span>
        </div>
      </div>

      <div class="row mt-2" v-if="onlyShowSpecified">
        <div class="col-md-12">
          <label class="font-weight-bold" for="inputEmail">
            <img width="20" class="d-inline" src="../assets/img/no.png" />
            Never {{ label }} on these pages:
          </label>
        </div>
      </div>

      <div v-if="onlyShowSpecified">
        <div v-for="(item, key) in nlayer" v-bind:key="key">
          <div
            id="do-not-show"
            class="row mt-1"
            :class="'row-' + item.id"
            v-if="onlyShowSpecified"
          >
            <div class="col-md-4">
              <select
                class="custom-select rule"
                :value="item.rule"
                @change="updateVal('n', item.id)"
              >
                <option value="simple">Simple match</option>
                <option value="exact">Exact match</option>
                <option value="contain">Contain word</option>
                <option value="regex">Regular expression</option>
              </select>
            </div>
            <div class="col-md-7 pl-0">
              <input
                type="text"
                :value="item.url"
                @keyup="updateVal('n', item.id)"
                class="form-control url"
                placeholder="https://example.com"
                autocomplete="off"
              />
            </div>
            <div class="font-weight-bold col-md-1 my-auto pl-0 cursor-pointer">
              <!-- <font  class="text-primary">+</font> -->
              <font
                style="display: none"
                @click="deleteRow(item.id)"
                class="text-danger n-delete"
              >
                <font-awesome-icon icon="trash" />
              </font>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-1" v-if="onlyShowSpecified">
        <div class="col-md-4"></div>
        <div class="col-md-7 pl-0 text-primary cursor-pointer text-right">
          <span @click="addRow('n')">+ add another url</span>
        </div>
      </div>

      <div class="row mt-1" v-if="onlyShowSpecified && this.isHowuku">
        <div class="col-md-12 mt-2">
          <a
            class="small mt-2"
            href="https://howuku.freshdesk.com/support/solutions/articles/150000073160-what-are-heatmap-url-match-types-"
            target="_blank"
          >
            <font-awesome-icon icon="question-circle" />

            what is the different between simple match, exact match, contain
            word, and regular expression?</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ['data', 'label'],
  data: function () {
    return {
      isHowuku: false,
      onlyShowSpecified: false,
      ylayer: [],
      nlayer: [],
      lastId: {
        y: 0,
        n: 0,
      },
    }
  },
  mounted() {
    this.isHowuku =
      window.location.host === 'app.howuku.com' ||
      window.location.host.includes('localhost')

    setTimeout(() => {
      if (this.data) {
        let arr = JSON.parse(this.data)
        if (arr.length) this.onlyShowSpecified = true

        for (let i in arr) {
          if (arr[i].allowed) {
            this.lastId.y = this.random()
            this.ylayer.push({
              id: this.lastId.y,
              url: arr[i].url,
              rule: arr[i].rule,
            })
          } else {
            this.lastId.n = this.random()
            this.nlayer.push({
              id: this.lastId.n,
              url: arr[i].url,
              rule: arr[i].rule,
            })
          }
        }
      }

      if (!this.lastId.y) {
        this.lastId.y = this.random()
        this.ylayer.push({
          id: this.lastId.y,
          url: '',
          rule: 'simple',
        })
      }

      if (!this.lastId.n) {
        this.lastId.n = this.random()
        this.nlayer.push({
          id: this.lastId.n,
          url: '',
          rule: 'simple',
        })
      }

      this.updateDeleteButton()
    }, 400)
  },
  methods: {
    updateVal(x, id) {
      if (x === 'y') {
        for (let i = 0; i < this.ylayer.length; i++) {
          if (this.ylayer[i].id === id) {
            this.ylayer[i].url = document.querySelector(
              '.row-' + id + ' input.url'
            ).value
            this.ylayer[i].rule = document.querySelector(
              '.row-' + id + ' select.rule'
            ).value
          }
        }
      }

      if (x === 'n') {
        for (let i = 0; i < this.nlayer.length; i++) {
          if (this.nlayer[i].id === id) {
            this.nlayer[i].url = document.querySelector(
              '.row-' + id + ' input.url'
            ).value
            this.nlayer[i].rule = document.querySelector(
              '.row-' + id + ' select.rule'
            ).value
          }
        }
      }
    },
    updateDeleteButton() {
      setTimeout(() => {
        let btnDelete = document.getElementsByClassName('y-delete')
        let what = document.getElementsByClassName('n-delete')
        if (what) {
          for (let j in what) {
            if (what[j] instanceof HTMLElement)
              what[j].style.display =
                document.querySelectorAll('#do-not-show .url').length >= 2
                  ? 'block'
                  : 'none'
          }
        }

        if (btnDelete) {
          for (let i in btnDelete) {
            if (btnDelete[i] instanceof HTMLElement)
              btnDelete[i].style.display =
                document.querySelectorAll('#do-show .url').length >= 2
                  ? 'block'
                  : 'none'
          }
        }
      }, 10)
    },
    deleteRow(id) {
      document
        .getElementsByClassName('row-' + id)[0]
        .parentNode.removeChild(document.getElementsByClassName('row-' + id)[0])
      this.updateDeleteButton()
    },
    addRow(type) {
      let id = this.random()
      let data = {
        id: id,
        url: '',
        rule: 'simple',
      }
      if (type === 'y') {
        this.ylayer.push(data)
        this.lastId.y = id
      }
      if (type === 'n') {
        this.nlayer.push(data)
        this.lastId.n = id
      }
      this.updateDeleteButton()
    },
    random() {
      return Math.floor(Math.random() * 10000 + 1)
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/UrlRuleForm.vue